import { AssessmentAISummaryHandlerProps } from "../../../types/assessment";

const AssessmentAISummaryHandler = ({isLoading, errors, data, children}: AssessmentAISummaryHandlerProps) => {
    if (isLoading) {
        return <div className="no-data-card">Loading, please wait...</div>;
      }
    
      if (errors) {
        return <div className="no-data-card">Error: {errors}</div>;
      }
    
      if (data.length === 0) {
        return <div className="no-data-card">No data found</div>;
      }

      return children;
};

export default AssessmentAISummaryHandler;